import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import YesNoAction from '../../../components/YesNoAction'
import TestIds from '../../../testIds'
import { PageContainer } from '../../../components/layout/PageContainer'
import { BackButton } from '../../../components/BackButton'
import { selectContactInfo } from '../../azure-b2c/storage'
import ContactCard from '../../../components/ContactCard'

export const ProductNotFound = () => {
  const navigate = useNavigate()
  const relationshipOwner = useSelector(selectContactInfo)

  return (
    <PageContainer data-testid={TestIds.pages.productNotFound}>
      <BackButton text='Products' onClick={() => navigate('/products')} />
      <>
        <YesNoAction
          display='Product not found'
          body='The details for the product you are trying to view are no longer available.'
        />
        <ContactCard
          sx={{ mt: 4 }}
          title={`Can’t find what your looking for? 
          Contact your Farmlands representative.`}
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    </PageContainer>
  )
}
